import React, { useRef, forwardRef } from 'react';
import Carousel from 'core/modules/Partials/Carousel/Carousel';
import FlexRowFillers from 'core/modules/Partials/FlexRowFiller/FlexRowFillers';

import { useHideIncompleteRow } from './hooks/useHideIncompleteRow';

import './List.scss';

function List(props, ref) {
  const {
    shouldUseCarousel, shouldHideIncompleteRow, children, dataAttributes, hasFillers, className = '',
    fillerClassName,
  } = props;
  const listRef = useRef(ref);

  useHideIncompleteRow(shouldHideIncompleteRow, shouldUseCarousel, listRef);

  if (shouldUseCarousel) {
    return <Carousel {...props} ref={ref || listRef} />;
  }

  return (
    <div ref={ref || listRef} className={`mn_list ${className}`} {...dataAttributes}>
      {children}
      <FlexRowFillers hasFillers={hasFillers} className={fillerClassName} />
    </div>
  );
}

export default forwardRef(List);
